import { RoomExtra, RoomExtraOption } from 'shared-types/Room';
import { PerDateV2 } from './PerDateV2';
import { PerDateTimeV2 } from './PerDateTimeV2';
import { PerTimeRangeV2 } from './PerTimeRangeV2';
import { PerDateRangeV2 } from './PerDateRangeV2';
import { PerDateTimeRangeV2 } from './PerDateTimeRangeV2';

export const controlTypesV2 = (extra: RoomExtra) => {
  const id = extra.id as number;
  const options: RoomExtraOption[] = 'options' in extra ? extra.options : [];
  return (
    {
      per_date: <PerDateV2 id={id} options={options} />,
      per_date_time: <PerDateTimeV2 id={id} options={options} />,
      per_time_range: <PerTimeRangeV2 id={id} options={options} />,
      per_date_range: <PerDateRangeV2 id={id} options={options} />,
      per_date_time_range: <PerDateTimeRangeV2 id={id} options={options} />,
    }[extra.type] || null
  );
};
